import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button, CardImg } from 'reactstrap';
import { NavLink } from 'reactstrap';

const HeroSection: React.FC = () => {
  return (
    <section className="hero-section py-5 mt-5">
      <Container>
        <Row className="align-items-center">
          <Col lg={6}>
            <h1>Empower Your Business with Our Multi-Tenant SaaS Platform</h1>
            <p>
              Streamline tenant management, subscriptions, and support with our secure, scalable
              SaaS solution designed for businesses of all sizes.
            </p>
            <div className="d-flex gap-3">
              <Button color="primary" size="lg">
                <NavLink href="#tenant-request" className="text-white text-decoration-none">
                  Start Free Trial
                </NavLink>
              </Button>
              {/* add login link to /login */}
              <Button color="secondary" size="lg">
                <Link to="/login" className="text-white text-decoration-none">
                  Login
                </Link>
              </Button>
            </div>
          </Col>
          <Col lg={6}>
            <CardImg
              src="https://placehold.co/600x400/ffffff/1e40af?text=SaaS+Dashboard+Preview&font=Inter"
              alt="Multi-tenant SaaS dashboard preview"
              className="img-fluid hero-img"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
